export default {
  about: "关于",
  detail: "组织详情",
  benefit: "福利",
  size: "组织规模",
  languageThai: "泰语",
  languageEnglish: "英语",

  contact: {
    title: "联系我们",
    website: "网站",
    email: "电子邮箱",
    contactNumber: "联系电话",
    personalContactNumber: "个人联系电话",
    location: "地址",
    location2: "地址",
    contactInfo: "联系方式",
    organizationPhone: "机构联系电话",
    enterPhoneNum: "请输入电话号码",
    phoneRequired: "请输入电话号码",
    phoneLengthValidation: "请输入 9 或 10 位电话号码",
    numberOnlyValidation: "请输入数字",
    to: "至",
    phoneOwnerName: "号码持有人姓名",
    enterPhoneOwnerName: "请输入号码持有人姓名",
    phoneOwnerNameRequired: "请输入号码持有人姓名",
    thaiOrEnglishOnlyValidation: "请输入泰文或英文字符",
    addPhoneNumber: "添加电话号码",
    emailRequired: "请输入电子邮箱",
    enterEmail: "请输入电子邮箱",
    max100Characters: "最多 100 个字符",
    emailFormatValidation:
      "请输入正确的邮箱格式，例如 name@example.com",
    enterWebsite: "请输入网站",
    example: "示例",
    branch: "分支机构",
    setMainBranch: "设为主分支",
    addBranch: "添加分支",
    viewInfo: "查看信息",
    locationGuideMessage: "您可以使用下方的 '添加分支' 按钮添加位置。",
    noLocationData: "未找到位置信息",

    organizationSize: "机构规模",
    selectOrganizationSize: "请选择机构规模",

    enterAbout: "请输入简介",
    aboutRequired: "请输入简介内容",

    enterBranch: "请输入分支机构",
    branchRequired: "请输入分支机构",

    addressDetail: "门牌号 / 村 / 大楼",
    enterAddressDetail: "请输入门牌号 / 村 / 大楼",
    locationRequired: "请输入地址信息",

    province: "省",
    selectProvince: "请选择省份",
    provinceRequired: "请选择省份",

    noSearchData: "未找到您搜索的数据",

    district: "区 / 县",
    selectDistrict: "请选择区/县",
    districtRequired: "请选择区/县",

    subDistrict: "街道 / 乡",
    selectSubDistrict: "请选择街道/乡",
    subDistrictRequired: "请选择街道/乡",

    postalCode: "邮政编码",
    enterPostalCode: "请输入邮政编码",
  },

  btn: {
    edit: "编辑企业资料",
  },

  img: {
    selectImage: "选择图片",
    banner: "横幅",
    logo: "标志",
    changeImage: "更换图片",
    recommendedBannerSize: "推荐横幅尺寸",
    maxUploadSize: "上传文件大小不能超过",
    fileFormat: "文件格式",
    uploadLogoRequired: "请上传标志图片",
  },

  business: {
    businessInfo: "企业信息",
    generalInfo: "基本信息",
    companyName: "公司名称",
    enterCompanyName: "请输入公司名称",
    organizationType: "机构类型",
    selectOrganizationType: "请选择机构类型",
    businessCategory: "业务类别",
    selectBusinessCategory: "请选择业务类别",
    aboutRequired: "请输入公司简介",
    max2000Characters: "文本超过 2000 个字符",
  },
};